import React, { useEffect, useState } from "react";
import styled from "styled-components";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { fontFamily } from "../styles/theme";
import { BASE_URL } from "../../../helper/base-url";

export function MaintenanceGate({ children }) {
  const location = useLocation();
  const [status, setStatus] = useState(null);
  const userData = JSON.parse(localStorage.getItem("userData") || "null");
  const isAdmin = userData?.user?.user_type === "admin";
  const onAdmin = location.pathname.startsWith("/admin");

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${BASE_URL}platform-status`)
      .then((res) => {
        if (!cancelled) setStatus(res?.data?.result?.data || null);
      })
      .catch(() => {
        if (!cancelled) setStatus(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!status?.maintenance || isAdmin || onAdmin) {
    return children;
  }

  return (
    <Wrap>
      <Card>
        <Title>We&apos;ll be back soon</Title>
        <Message>{status.maintenanceMessage}</Message>
      </Card>
    </Wrap>
  );
}

const Wrap = styled.div`
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
`;

const Card = styled.div`
  max-width: 480px;
  text-align: center;
  padding: 32px 28px;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  background: #fff;
`;

const Title = styled.h1`
  margin: 0 0 12px;
  font-family: ${fontFamily.font};
  font-size: 22px;
  font-weight: 700;
  color: #111827;
`;

const Message = styled.p`
  margin: 0;
  font-family: ${fontFamily.font};
  font-size: 14px;
  line-height: 1.6;
  color: #4b5563;
`;
